class CompanyService {
  constructor($http, $rootScope) {
    "ngInject";
    this.name = 'CompanyService';
    this.$http = $http;
    this.baseUrl = $rootScope.apiHost +'/api/admin/companies';

  }

  getCompany() {
    return this.$http.get(this.baseUrl+'/mycompany', {withCredentials: true});
  }


}

export default CompanyService;



// WEBPACK FOOTER //
// ./client/common/services/company/company.service.js